import { MyBtn } from '~/components/ui/MyBtn'
import { MyIcon } from '~/components/ui/MyIcon'
import { useValidateAuth } from '~/hooks/useValidateAuth'
import Router from 'next/router'
import { RemainTimesBtn } from '../RemainTimesBtn'
import { MyContainer } from '~/components/ui/MyContainer'
import { toCDNImage } from '~/utils'
import { AutoScroll } from '~/components/ui/AutoScroll'
import { ILabHeader, pattern2Header } from '~/configs/ai'

import styles from './LabHeader.module.css'
import { patternAtom } from '../ai-form/atom'
import { useAtom } from 'jotai'

export const LabHeader: React.FC<{
  lockData?: ILabHeader
  link?: string
  linkLabel?: string
}> = ({ lockData, link = '/ai/mine', linkLabel = '我的创作' }) => {
  const [pattern] = useAtom(patternAtom)

  const data =
    lockData || pattern2Header[pattern as keyof typeof pattern2Header]

  const { validateIsLogin } = useValidateAuth()

  return (
    <div
      style={{
        background: `url(${toCDNImage(
          '/images/ai/depth2img.jpg'
        )}) no-repeat center center/100% 100%`,
      }}
    >
      <MyContainer>
        <div className="flex py-4 justify-between items-center">
          <div className="w-[662px]">
            <div className="flex items-center justify-between">
              <div className="text-neutral-800 font-semibold text-xl">
                {data?.title}
              </div>
              <div className="flex items-center">
                <RemainTimesBtn />
                <a
                  className="ml-2"
                  onClick={e => {
                    e.preventDefault()
                    if (validateIsLogin()) {
                      Router.push(link)
                    }
                  }}
                >
                  <MyBtn $dark>
                    <div className="flex items-center">
                      <MyIcon icon="folder-open" className="text-[20px]" />
                      <span className="ml-1">{linkLabel}</span>
                    </div>
                  </MyBtn>
                </a>
              </div>
            </div>
            <div className="text-sm text-neutral-500 mt-4">{data?.desc}</div>
          </div>

          <div className="w-[708px] rounded-lg overflow-hidden">
            <AutoScroll
              activeIndex={0}
              hasArrow={(data?.imgs || []).length > 4}
              className={styles.autoScroll}
              gutter={0}
              distanceCoefficient={1}
            >
              <div className="flex items-center">
                {data?.imgs?.map(item => {
                  return (
                    <img
                      key={item}
                      src={item}
                      alt=""
                      className="block w-[177px] h-[177px]"
                    />
                  )
                })}
              </div>
            </AutoScroll>
          </div>
        </div>
      </MyContainer>
    </div>
  )
}
